import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import React from "react";
import { AdyenIssueIA } from "./instantAnswersComponents/payments/AdyenIssueIA";
export var adyenIssue = function adyenIssue(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return ADYEN_ISSUE_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return ADYEN_ISSUE_DESCRIPTION();
    }
  };
};
var ADYEN_ISSUE_TITLE = function ADYEN_ISSUE_TITLE(strictLocalize) {
  return strictLocalize({
    id: "SCGRJ3",
    defaultMessage: [{
      "type": 0,
      "value": "Résolution des problèmes Adyen"
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return {
    label: strictLocalize({
      id: "Vf1Bna",
      defaultMessage: "Contact Adyen"
    }),
    getLink: function getLink() {
      return "https://help.adyen.com/en_US/knowledge";
    }
  };
};
var ADYEN_ISSUE_DESCRIPTION = function ADYEN_ISSUE_DESCRIPTION() {
  return /*#__PURE__*/React.createElement(AdyenIssueIA, null);
};